import { useState, useRef, useEffect } from "react";
import { Icon, Box, Portal, useOutsideClick } from "@chakra-ui/react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { DrawerList, IconButton } from "barte-design-system";
import type { UserRowActionsMenuProps } from "./user-row-actions-menu.type";
import styles from "./user-row-actions-menu.module.css";

export const UserRowActionsMenu = ({ user, onEdit, onDelete }: UserRowActionsMenuProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, right: 0 });
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isMenuOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPosition({
        top: rect.bottom + window.scrollY,
        right: window.innerWidth - rect.right,
      });
    }
  }, [isMenuOpen]);

  useOutsideClick({
    ref: menuRef,
    handler: () => setIsMenuOpen(false),
  });

  return (
    <div className={styles["menu-container"]}>
      <IconButton
        ref={buttonRef}
        aria-label="Menu"
        variant="outline"
        onClick={() => setIsMenuOpen((prev) => !prev)}
      >
        <Icon as={BsThreeDotsVertical} boxSize={4} />
      </IconButton>

      {isMenuOpen && (
        <Portal>
          <Box
            className={styles["portal-menu"]}
            top={`${menuPosition.top}px`}
            right={`${menuPosition.right}px`}
            ref={menuRef}
          >
            <DrawerList
              items={[
                {
                  label: "Editar usuário",
                  onClick: () => {
                    setIsMenuOpen(false);
                    onEdit(user);
                  },
                },
                {
                  label: "Excluir usuário",
                  onClick: () => {
                    setIsMenuOpen(false);
                    onDelete(user);
                  },
                },
              ]}
            />
          </Box>
        </Portal>
      )}
    </div>
  );
};
